export default "__VITE_ASSET__gFewf_Ut__"